import { Link } from "react-router-dom";
import BaseNavBar from "./BaseNavBar";
import { getCountries } from "./CountryUtil";

function SiteSwitcher(props) {
    return (
        <div className="main-layout">
            <div id="about" className="about">
                <div className="row">
                    <div class="col-md-12">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="switchertitle">
                                <h2>Select Country</h2>
                            </div>
                            <div className="contact_bg  col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                {getCountries().map((country, i) => <Link to={"/"+country.id+"/"} className="send" style={{ margin: 5,padding:10 }}>{country.desc}</Link>)}
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SiteSwitcher;
